import { createSelector } from '@reduxjs/toolkit';
import {
    getBidderMobileVerified,
    getDefaultAddress,
    getDefaultAddressIsVerified,
    isUserAtLeastPartiallyRegistered,
} from '../user.selectors';
import { getDefaultBidderCreditCard } from '@/redux/modules/account/payments/creditCard/creditCard/creditCard.selectors';
import { PaymentProviders } from '@/enums';

// user selectors can get very, very complex.
// Because of that, circular dependencies are going to be common.
// To avoid that, this file should contain selectors that pull from multiple slices.
// When it's all minified it would run fine, since everything's in one file,
// but test runs exploderate. 💥

export const getIsProfileFullyCompleted = createSelector(
    [
        isUserAtLeastPartiallyRegistered,
        getDefaultAddress,
        getDefaultAddressIsVerified,
        (state) => getDefaultBidderCreditCard(state, PaymentProviders.Payrix),
        getBidderMobileVerified,
    ],
    (userPartiallyRegistered, defaultAddress, addressVerified, defaultCreditCard, mobileVerified) => {
        return (
            userPartiallyRegistered &&
            Boolean(defaultAddress?.firstName) &&
            Boolean(defaultAddress?.lastName) &&
            Boolean(defaultAddress?.address1) &&
            addressVerified &&
            Boolean(defaultCreditCard?.id) &&
            mobileVerified
        );
    }
);
